export function formEncode(params: { [key: string]: (number | string | boolean | undefined) }) {
    return Object.entries(params)
        .reduce((array, kv) =>
            kv[1] !== undefined
                ? array.concat(`${encodeURIComponent(kv[0])}=${encodeURIComponent(kv[1])}`)
                : array
            , [] as string[])
        .join('&');
}
